/**
 * Cart quantity limits before add-to-cart (same rules as commit 0ceec10f).
 * Keeps theme.js untouched; runs after it on document capture + replay.
 */
(function () {
  "use strict";

  window.theme = window.theme || {};
  if (theme.cartQuantityLimits && theme.cartQuantityLimits.__atcBridgeInstalled) return;

  var CART_LIMITS_BYPASS_SUBMIT = "__cartLimitsBypassSubmit";
  var CART_LIMITS_BYPASS_QUICK_ADD = "__cartLimitsBypassQuickAdd";
  var CART_LIMITS_BYPASS_GWP = "__cartLimitsBypassGwp";
  /** Reverses HTML entities from Shopify's | t output when still present after JSON.parse. */
  function decodeHtmlEntities(str) {
    if (typeof str !== "string" || !str) return str;
    var ta = document.createElement("textarea");
    ta.innerHTML = str;
    return ta.value;
  }

  var L = {
    __atcBridgeInstalled: true,
    getConfig() {
      var el = document.getElementById("CartQuantityLimitsSettings");
      if (!el) {
        return {
          cartTotalMax: 25,
          saleLineMax: 5,
          msgAddTotal: "You've reached the maximum number of items in your cart.",
          msgAddSale:
            "You've reached the maximum for sale or discounted items in your cart.",
        };
      }
      try {
        var t = JSON.parse(el.textContent || "{}");
        var s = parseInt(t.cartTotalMax, 10);
        if (isNaN(s) || s < 1) s = parseInt(t.defaultMax, 10);
        if (isNaN(s) || s < 1) s = 25;
        var r = parseInt(t.saleLineMax, 10);
        if (isNaN(r) || r < 1) r = parseInt(t.saleOrDiscountMax, 10);
        if (isNaN(r) || r < 1) r = 5;
        var msgTotal = t.msgAddTotal || "You've reached the maximum number of items in your cart.";
        var msgSale =
          t.msgAddSale ||
          "You've reached the maximum for sale or discounted items in your cart.";
        return {
          cartTotalMax: Math.max(1, s),
          saleLineMax: Math.max(1, r),
          msgAddTotal: decodeHtmlEntities(msgTotal),
          msgAddSale: decodeHtmlEntities(msgSale),
        };
      } catch (_e) {
        return {
          cartTotalMax: 25,
          saleLineMax: 5,
          msgAddTotal: "You've reached the maximum number of items in your cart.",
          msgAddSale:
            "You've reached the maximum for sale or discounted items in your cart.",
        };
      }
    },
    _getVariantSaleMap() {
      var el = document.getElementById("CartVariantSaleMap");
      if (!el) return {};
      try {
        return JSON.parse(el.textContent || "{}");
      } catch (_e) {
        return {};
      }
    },
    lineIsSaleOrDiscount(line) {
      if (!line) return false;
      var variantSaleMap = this._getVariantSaleMap();
      return variantSaleMap[String(line.variant_id)] === true;
    },
    lineIsGift(line) {
      if (!line || !line.properties) return false;
      return !!(line.properties._GWP || line.properties._threshold_free_gift || line.properties._auto_gwp_free_gift);
    },
    currentQtyForVariant(cart, variantId) {
      var r = 0;
      if (!cart || !cart.items) return 0;
      cart.items.forEach(function (item) {
        if (Number(item.variant_id) === Number(variantId)) r += item.quantity;
      });
      return r;
    },
    saleQtyInCart(cart) {
      var total = 0;
      if (!cart || !cart.items) return 0;
      cart.items.forEach(function (item) {
        if (L.lineIsGift(item)) return;
        if (L.lineIsSaleOrDiscount(item)) total += item.quantity;
      });
      return total;
    },
    canAddItems(cart, variantId, addQty, isSale) {
      if (!cart || !cart.items) return { ok: true };
      var cfg = this.getConfig();
      var add = parseInt(String(addQty), 10) || 0;
      if (cart.item_count + add > cfg.cartTotalMax) return { ok: false, reason: "total" };
      if (!isSale) return { ok: true };
      return L.saleQtyInCart(cart) + add > cfg.saleLineMax ? { ok: false, reason: "sale" } : { ok: true };
    },
    validateLineQuantity(cart, lineIndex, requestedQty) {
      var qty = parseInt(String(requestedQty), 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      if (!cart || !cart.items) return { ok: true, qty: qty };
      var line = cart.items[lineIndex - 1];
      if (!line) return { ok: true, qty: qty };

      var input =
        document.getElementById("Quantity-" + lineIndex) ||
        document.getElementById("Drawer-quantity-" + lineIndex);
      if (input) {
        var domMax = parseInt(String(input.getAttribute("max")), 10);
        if (!isNaN(domMax) && domMax > 0) {
          if (qty > domMax) {
            return { ok: false, reason: "total", qty: domMax };
          }
          return { ok: true, qty: qty };
        }
      }

      var cfg = this.getConfig();
      var others = cart.item_count - line.quantity;
      if (others + qty > cfg.cartTotalMax) {
        var totalCap = Math.max(1, cfg.cartTotalMax - others);
        return { ok: false, reason: "total", qty: totalCap };
      }
      if (!L.lineIsGift(line) && L.lineIsSaleOrDiscount(line)) {
        var saleOthers = L.saleQtyInCart(cart) - line.quantity;
        if (saleOthers + qty > cfg.saleLineMax) {
          var saleCap = Math.max(1, cfg.saleLineMax - saleOthers);
          return { ok: false, reason: "sale", qty: saleCap };
        }
      }
      return { ok: true, qty: qty };
    },
    getAddBlockedMessage(reason) {
      var t = this.getConfig();
      return reason === "sale" ? t.msgAddSale : t.msgAddTotal;
    },
    showDrawerCartError(reason) {
      var el = document.getElementById("CartDrawer-CartErrors");
      if (el) {
        el.textContent = this.getAddBlockedMessage(reason);
        el.classList.remove("hidden");
      }
      var drawer = document.getElementById("CartDrawer");
      if (drawer && typeof drawer.open === "function") {
        drawer.open();
      }
    },
    clearDrawerCartError() {
      var el = document.getElementById("CartDrawer-CartErrors");
      if (!el) return;
      el.textContent = "";
      el.classList.add("hidden");
    },
    _atcRefreshTimer: null,
    scheduleRefreshAtcState() {
      var self = this;
      clearTimeout(this._atcRefreshTimer);
      this._atcRefreshTimer = setTimeout(function () {
        self.refreshAddToCartButtonsState();
      }, 250);
    },
    refreshAddToCartButtonsState() {
      var cartUrl = (window.routes && window.routes.cart_url) || "/cart";
      fetch(cartUrl + ".js", { credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          document.querySelectorAll("[js-add-to-cart]").forEach(function (btn) {
            if (btn.closest && btn.closest("s-modal.quick-view-modal")) return;
            var vid = btn.dataset.variantId;
            if (!vid) return;
            var pdpPrimaryAtc =
              btn.matches && (btn.matches("[js-main-add-to-cart]") || btn.matches("[js-sticky-atc]"));
            var upsellOrQuickAddHost = btn.closest && btn.closest("quick-add");
            var onSale = btn.dataset.variantOnSale === "true";
            var check = L.canAddItems(cart, vid, 1, onSale);
            if (btn.dataset.variantAvailable === "false") {
              btn.disabled = true;
              btn.setAttribute("disabled", "");
            } else if (check.ok) {
              btn.disabled = false;
              btn.removeAttribute("disabled");
              btn.removeAttribute("aria-disabled");
            } else if (pdpPrimaryAtc || upsellOrQuickAddHost) {
              btn.disabled = false;
              btn.removeAttribute("disabled");
              btn.removeAttribute("aria-disabled");
            } else {
              btn.disabled = true;
              btn.setAttribute("disabled", "");
              btn.setAttribute("aria-disabled", "true");
            }
          });
        })
        .catch(function () { });
    },
  };

  theme.cartQuantityLimits = L;

  function fetchCartJson() {
    var cartUrl = (window.routes && window.routes.cart_url) || "/cart";
    return fetch(cartUrl + ".js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function getVariantPriceMapElement(sProduct) {
    if (sProduct && sProduct.dataset && sProduct.dataset.productId) {
      var qvMap = document.getElementById("ProductVariantPriceMap-qv-" + sProduct.dataset.productId);
      if (qvMap) return qvMap;
    }
    if (sProduct && sProduct.querySelector) {
      var inside =
        sProduct.querySelector("#ProductVariantPriceMap") ||
        sProduct.querySelector('[id^="ProductVariantPriceMap-qv-"]');
      if (inside) return inside;
    }
    return document.getElementById("ProductVariantPriceMap");
  }

  function resolveIsSaleForFormVariant(variantId, sProduct) {
    var mapEl = getVariantPriceMapElement(sProduct);
    if (mapEl) {
      try {
        var pm = JSON.parse(mapEl.textContent || "{}");
        var prow = pm[String(variantId)];
        if (prow && Number(prow.compare_at_price) > Number(prow.price)) {
          return true;
        }
      } catch (_e) { }
    }
    var jsonEl = null;
    if (sProduct && sProduct.dataset && sProduct.dataset.productJsonId) {
      jsonEl = document.getElementById(sProduct.dataset.productJsonId);
    }
    if (!jsonEl) jsonEl = document.getElementById("ProductJSON");
    if (jsonEl) {
      try {
        var data = JSON.parse(jsonEl.textContent || "{}");
        var variants = data.variants || [];
        var v = variants.find(function (row) {
          return String(row.id) === String(variantId);
        });
        if (
          v &&
          !isNaN(Number(v.compare_at_price)) &&
          !isNaN(Number(v.price)) &&
          Number(v.compare_at_price) > Number(v.price)
        ) {
          return true;
        }
      } catch (_e2) { }
    }
    if (sProduct && sProduct.querySelector) {
      var atcBtn =
        sProduct.querySelector("[js-main-add-to-cart]") || sProduct.querySelector("[js-add-to-cart]");
      if (
        atcBtn &&
        atcBtn.dataset.variantOnSale === "true" &&
        String(atcBtn.dataset.variantId) === String(variantId)
      ) {
        return true;
      }
    }
    return false;
  }

  function showFormError(sProductEl, message) {
    if (!sProductEl) return;
    var wrap = sProductEl.querySelector("[js-error-message]");
    if (!wrap) return;
    if (message) {
      wrap.innerHTML = message;
      wrap.classList.remove("hidden");
    } else {
      wrap.innerHTML = "";
      wrap.classList.add("hidden");
    }
  }

  function replaySubmit(form) {
    var replay = new Event("submit", { bubbles: true, cancelable: true });
    replay[CART_LIMITS_BYPASS_SUBMIT] = true;
    form.dispatchEvent(replay);
  }

  document.addEventListener(
    "submit",
    function (ev) {
      var form = ev.target;
      if (!form || !form.matches || !form.matches("form[js-product-form]")) return;
      if (ev[CART_LIMITS_BYPASS_SUBMIT]) return;
      if (form.closest("s-product")) return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();

      (function () {
        fetchCartJson()
          .then(function (cartData) {
            var s = new FormData(form);
            var variantId = s.get("id");
            var qtyRaw = s.get("quantity") || 1;
            var mainQty = parseInt(String(qtyRaw), 10) || 1;
            var items = [{ id: variantId, quantity: qtyRaw }];
            var autoGwp = s.get("properties[_auto_gwp]");
            if (autoGwp) {
              try {
                var ids = JSON.parse(autoGwp);
                ids.forEach(function (gid) {
                  items.push({ id: gid, quantity: 1, properties: { _auto_gwp_free_gift: String(variantId) } });
                });
              } catch (_parse) { }
            }
            var totalDelta = items.reduce(function (acc, row) {
              return acc + (parseInt(String(row.quantity), 10) || 0);
            }, 0);

            var sProduct = form.closest("s-product");
            var isSale = resolveIsSaleForFormVariant(String(variantId), sProduct);
            var cfg = L.getConfig();

            if (cartData.item_count + totalDelta > cfg.cartTotalMax) {
              L.showDrawerCartError("total");
              showFormError(sProduct, L.getAddBlockedMessage("total"));
              return;
            }
            if (isSale && L.saleQtyInCart(cartData) + mainQty > cfg.saleLineMax) {
              L.showDrawerCartError("sale");
              showFormError(sProduct, L.getAddBlockedMessage("sale"));
              return;
            }
            L.clearDrawerCartError();
            showFormError(sProduct, false);
            replaySubmit(form);
          })
          .catch(function () {
            replaySubmit(form);
          });
      })();
    },
    true,
  );

  function replayClick(el, flagKey) {
    var r = new MouseEvent("click", { bubbles: true, cancelable: true, view: window });
    r[flagKey] = true;
    el.dispatchEvent(r);
  }

  function checkQuickViewAtcLimits(form, btn, cartData) {
    var sProduct = form.closest("s-product");
    var variantId = btn.dataset.variantId || new FormData(form).get("id");
    if (!variantId) return { ok: true };
    var mainQty = parseInt(String(new FormData(form).get("quantity") || 1), 10) || 1;
    var onSale =
      btn.dataset.variantOnSale === "true" || resolveIsSaleForFormVariant(String(variantId), sProduct);
    var cfg = L.getConfig();
    if (cartData.item_count + mainQty > cfg.cartTotalMax) {
      return { ok: false, reason: "total" };
    }
    if (onSale && L.saleQtyInCart(cartData) + mainQty > cfg.saleLineMax) {
      return { ok: false, reason: "sale" };
    }
    return { ok: true };
  }

  function dispatchFormSubmitWithBypass(form) {
    var replay = new Event("submit", { bubbles: true, cancelable: true });
    replay[CART_LIMITS_BYPASS_SUBMIT] = true;
    form.dispatchEvent(replay);
  }

  document.addEventListener(
    "click",
    function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest("[js-add-to-cart]");
      if (!btn || !btn.closest || !btn.closest("s-modal.quick-view-modal")) return;
      if (btn.closest("quick-add")) return;
      if (ev[CART_LIMITS_BYPASS_QV_CLICK]) return;
      var form = btn.closest("form[js-product-form]");
      if (!form) return;
      if (form.closest("s-product")) return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();

      fetchCartJson()
        .then(function (cartData) {
          var check = checkQuickViewAtcLimits(form, btn, cartData);
          var sProduct = form.closest("s-product");
          if (!check.ok) {
            L.showDrawerCartError(check.reason);
            showFormError(sProduct, L.getAddBlockedMessage(check.reason));
            return;
          }
          L.clearDrawerCartError();
          showFormError(sProduct, false);
          dispatchFormSubmitWithBypass(form);
        })
        .catch(function () {
          dispatchFormSubmitWithBypass(form);
        });
    },
    true,
  );

  document.addEventListener(
    "click",
    function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest("[js-add-to-cart]");
      if (!btn || !btn.closest || !btn.closest("quick-add")) return;
      if (ev[CART_LIMITS_BYPASS_QUICK_ADD]) return;
      if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();

      var vid = btn.dataset.variantId;
      if (!vid) {
        replayClick(btn, CART_LIMITS_BYPASS_QUICK_ADD);
        return;
      }

      fetchCartJson()
        .then(function (cartData) {
          var onSale = btn.dataset.variantOnSale === "true";
          var check = L.canAddItems(cartData, vid, 1, onSale);
          if (!check.ok) {
            L.showDrawerCartError(check.reason);
            return;
          }
          L.clearDrawerCartError();
          replayClick(btn, CART_LIMITS_BYPASS_QUICK_ADD);
        })
        .catch(function () {
          replayClick(btn, CART_LIMITS_BYPASS_QUICK_ADD);
        });
    },
    true,
  );

  document.addEventListener(
    "click",
    function (ev) {
      var gwpBtn = ev.target && ev.target.closest && ev.target.closest("[js-gwp-atc]");
      if (!gwpBtn) return;
      if (ev[CART_LIMITS_BYPASS_GWP]) return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();

      var block = gwpBtn.closest("[js-gwp-block]");
      var vid = block && block.dataset && block.dataset.variantId;
      if (!vid) {
        replayClick(gwpBtn, CART_LIMITS_BYPASS_GWP);
        return;
      }

      fetchCartJson()
        .then(function (cartData) {
          var check = L.canAddItems(cartData, vid, 1, false);
          if (!check.ok) {
            L.showDrawerCartError(check.reason);
            return;
          }
          L.clearDrawerCartError();
          replayClick(gwpBtn, CART_LIMITS_BYPASS_GWP);
        })
        .catch(function () {
          replayClick(gwpBtn, CART_LIMITS_BYPASS_GWP);
        });
    },
    true,
  );

  function isCartQuantityInput(el) {
    return (
      el &&
      el.matches &&
      el.matches('input.quantity__input[name="updates[]"]') &&
      el.dataset &&
      el.dataset.index
    );
  }

  var _cartQtyInputTimers = {};

  function scheduleCartQuantityInputChange(input) {
    var lineIndex = parseInt(input.dataset.index, 10);
    if (isNaN(lineIndex) || lineIndex < 1) return;
    clearTimeout(_cartQtyInputTimers[lineIndex]);
    _cartQtyInputTimers[lineIndex] = setTimeout(function () {
      delete _cartQtyInputTimers[lineIndex];
      applyCartQuantityInputChange(input);
    }, 350);
  }

  function applyCartQuantityInputChange(input) {
    var host = input.closest("cart-items") || input.closest("cart-drawer-items");
    if (!host || typeof host.updateQuantity !== "function") return;
    var lineIndex = parseInt(input.dataset.index, 10);
    if (isNaN(lineIndex) || lineIndex < 1) return;
    var requested = parseInt(input.value, 10);
    if (isNaN(requested)) requested = 0;
    var fieldName = input.getAttribute("name") || "updates[]";

    fetchCartJson()
      .then(function (cartData) {
        var validated = L.validateLineQuantity(cartData, lineIndex, requested);
        if (validated.qty !== requested) {
          input.value = String(validated.qty);
        }
        if (!validated.ok) {
          window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
          L.showDrawerCartError(validated.reason);
        } else {
          L.clearDrawerCartError();
        }
        host.updateQuantity(String(lineIndex), validated.qty, fieldName);
        if (host.dataset.source === "cartPage") {
          var drawerHost = document.querySelector("cart-drawer-items");
          if (drawerHost && drawerHost !== host) {
            drawerHost.updateQuantity(String(lineIndex), validated.qty, fieldName);
          }
        }
      })
      .catch(function () {
        host.updateQuantity(String(lineIndex), requested, fieldName);
      });
  }

  document.addEventListener(
    "change",
    function (ev) {
      var input = ev.target;
      if (!isCartQuantityInput(input)) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      scheduleCartQuantityInputChange(input);
    },
    true,
  );

  document.addEventListener(
    "blur",
    function (ev) {
      var input = ev.target;
      if (!isCartQuantityInput(input)) return;
      var maxAttr = parseInt(input.getAttribute("max"), 10);
      var minAttr = parseInt(input.getAttribute("min"), 10);
      if (isNaN(minAttr) || minAttr < 0) minAttr = 0;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = minAttr;
      if (!isNaN(maxAttr) && maxAttr > 0 && val > maxAttr) {
        input.value = String(maxAttr);
        window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
      }
      if (val < minAttr) input.value = String(minAttr);
    },
    true,
  );

  if (theme.utils && theme.utils.subscriptions && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    theme.utils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      L.scheduleRefreshAtcState();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      L.scheduleRefreshAtcState();
    });
  } else {
    L.scheduleRefreshAtcState();
  }
})();
